import React from 'react';
import styles from './HeaderProposta.module.scss';

function HeaderProposta({
    numeroProposta = '',
    nomeIndicador = '',
    numrVersao = '',
    descTipoProposta = '',
    className = '',
}) {
    const Label = ({ descricao, value }) => {
        return (
            <div className={styles.label}>
                <span>{descricao}</span>
                <span>{value}</span>
            </div>
        );
    };

    return (
        <div
            className={`${styles.boxLabels} ${descTipoProposta || numrVersao ? styles.border : ''}`}
        >
            {(descTipoProposta || numrVersao) && (
                <div className={`${styles.containerLabels} ${className}`}>
                    <Label descricao="Versão:" value={numrVersao} />
                    <Label descricao="Tipo da Proposta:" value={descTipoProposta} />
                </div>
            )}
            <div className={`${styles.containerLabels} ${className}`}>
                <Label descricao="Nº da Proposta:" value={numeroProposta} />
                <Label descricao="Nome do Indicador:" value={nomeIndicador} />
            </div>
        </div>
    );
}

export default HeaderProposta;
